import { Spin } from "antd";
import { FunctionComponent } from "enzyme";
import { h } from "preact";
import { Container } from "./styled";

interface SplashProps {
  title?: string;
}

const SplashScreen: FunctionComponent<SplashProps> = (props) => {
  return <Container>
    {<Spin tip={props.title || 'กำลังโหลดข้อมูล'} /> as JSX.Element}
  </Container>
}

export default SplashScreen;